import React from 'react';
import { Popover } from 'antd';
import styles from './emailChangeConfirm.module.scss';

interface EmailChangeConfirmProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentEmail: string;
  newEmail: string;
  onDiscard: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
  heading?: string;
  warningMessage?: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

const EmailChangeConfirm: React.FC<EmailChangeConfirmProps> = ({
  open,
  onOpenChange,
  currentEmail,
  newEmail,
  onDiscard,
  onConfirm,
  children,
  heading = 'Your email address was changed!',
  warningMessage,
  cancelLabel = 'No, Discard',
  confirmLabel = 'Yes, Save',
}) => {
  const content = (
    <div className={styles.content}>
      <img src="/assets/warning-sign-icon.svg" alt="" className={styles.icon} />

      <p className={styles.heading}>{heading}</p>

      {warningMessage ? (
        <p className={styles.body}>{warningMessage}</p>
      ) : (
        <>
          <p className={styles.body}>Your account will no longer be accessible through {currentEmail}.</p>
          <p className={styles.body}>
            Saving these changes will require you to re-log into your account using the new email <span className={styles.newEmail}>{newEmail}</span>
          </p>
        </>
      )}

      <p className={styles.prompt}>Continue?</p>

      <div className={styles.actions}>
        <button type="button" className={styles.btn} onClick={onDiscard}>
          {cancelLabel}
        </button>
        <button type="button" className={styles.btn} onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={onOpenChange}
      placement="top"
      arrow={false}
      overlayClassName={styles.popover}
    >
      {children}
    </Popover>
  );
};

export default EmailChangeConfirm;
